import { FieldTypes } from '../../../constants'
import { FieldMap } from '../../../types'

export const generalPhysicalExamField: FieldMap = {
  name: 'General Physical Exam',
  children: {
    generalAppearance: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'General Appearance',
      optional: true,
    },
    heent: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'HEENT',
      optional: true,
    },
    neck: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Neck',
      optional: true,
    },
    skin: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Skin',
      optional: true,
    },
    breast: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Breast',
      optional: true,
    },
    lungs: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Lungs',
      optional: true,
    },
    heart: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Heart',
      optional: true,
    },
    abdomen: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Abdomen',
      optional: true,
    },
    neuro: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Neuro',
      optional: true,
    },
    extremities: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Extremities',
      optional: true,
    },
  },
}
